import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { NotificationProvider } from "./contexts/NotificationContext";
import "@/App.css";

// Public Pages
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AuthCallback from "./pages/AuthCallback";
import ContactPage from "./pages/ContactPage";
import FAQPage from "./pages/FAQPage";
import CodeOfConductPage from "./pages/CodeOfConductPage";

// Projects
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import CreateProject from "./pages/CreateProject";

// Forum
import Forum from "./pages/Forum";
import ForumCategory from "./pages/ForumCategory";
import ThreadDetail from "./pages/ThreadDetail";
import CreateThread from "./pages/CreateThread";

// Events
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";

// Resources
import Resources from "./pages/Resources";
import ResourceDetail from "./pages/ResourceDetail";

// Users & Community
import Mentors from "./pages/Mentors";
import MemberProfile from "./pages/MemberProfile";
import Leaderboard from "./pages/Leaderboard";

// Dashboard (Protected)
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import MyProjects from "./pages/MyProjects";
import Messages from "./pages/Messages";
import Notifications from "./pages/Notifications";
import Bookmarks from "./pages/Bookmarks";

// Admin
import AdminDashboard from "./pages/AdminDashboard";

import { ProtectedRoute } from "./components/ProtectedRoute";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Public Pages */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/code-of-conduct" element={<CodeOfConductPage />} />
      
      {/* Projects */}
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:projectId" element={<ProjectDetail />} />
      <Route path="/projects/create" element={<ProtectedRoute><CreateProject /></ProtectedRoute>} />
      
      {/* Forum */}
      <Route path="/forum" element={<Forum />} />
      <Route path="/forum/category/:categoryId" element={<ForumCategory />} />
      <Route path="/forum/thread/:threadId" element={<ThreadDetail />} />
      <Route path="/forum/create" element={<ProtectedRoute><CreateThread /></ProtectedRoute>} />
      
      {/* Events */}
      <Route path="/events" element={<Events />} />
      <Route path="/events/:eventId" element={<EventDetail />} />
      
      {/* Resources */}
      <Route path="/resources" element={<Resources />} />
      <Route path="/resources/:resourceId" element={<ResourceDetail />} />
      
      {/* Community */}
      <Route path="/mentors" element={<Mentors />} />
      <Route path="/users/:userId" element={<MemberProfile />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      
      {/* Dashboard (Protected) */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/my-projects" element={<ProtectedRoute><MyProjects /></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/messages/:userId" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
      <Route path="/bookmarks" element={<ProtectedRoute><Bookmarks /></ProtectedRoute>} />
      
      {/* Admin */}
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <NotificationProvider>
      <div className="min-h-screen bg-white">
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </NotificationProvider>
  );
}

export default App;
